class StyleInMotion {
  constructor(section) {
    this.section = section;
    this.slider = section.querySelector('[data-slider]');
    this.slides = section.querySelector('[data-slides]');
    this.prevBtn = section.querySelector('[data-slider-prev]');
    this.nextBtn = section.querySelector('[data-slider-next]');
    this.videos = section.querySelectorAll('[data-video-player] video');
    
    this.init();
  }
  
  init() {
    // Navigation
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn.addEventListener('click', () => this.scroll('next'));
    }
    
    // Video controls
    this.videos.forEach((video, index) => {
      const slide = video.closest('[data-slide]');
      const playPauseBtn = slide.querySelector('[data-play-pause]');
      const muteBtn = slide.querySelector('[data-mute]');
      const videoPlayer = slide.querySelector('[data-video-player]');
      
      // Auto-play first video
      if (index === 0) {
        video.play();
        videoPlayer.classList.add('is-active');
      }
      
      // Play/Pause
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      }
      
      // Mute/Unmute
      if (muteBtn) {
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
        });
      }
      
      // Show video player when playing
      video.addEventListener('play', () => {
        videoPlayer.classList.add('is-active');
      });
    });
    
    // Intersection Observer for auto-play
    this.observeVideos();
  }
  
  scroll(direction) {
    const slideWidth = this.slides.querySelector('[data-slide]').offsetWidth;
    const scrollAmount = direction === 'next' ? slideWidth + 20 : -(slideWidth + 20);
    this.slides.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
  
  observeVideos() {
    const options = {
      root: null,
      threshold: 0.5
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (video) {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        }
      });
    }, options);
    
    this.section.querySelectorAll('[data-slide]').forEach(slide => {
      observer.observe(slide);
    });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="style-in-motion"]');
  sections.forEach(section => new StyleInMotion(section));
});

// Shopify theme editor support
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="style-in-motion"]');
    if (section) new StyleInMotion(section);
  });
}
